module.exports = __webpack_public_path__ + "232cc123547fd7cf965cb06a4b6b3bd1.pdf";